// BaselineOverlay.js — Baseline animée quand aucune fenêtre n'est ouverte

import React, { useState, useEffect } from 'react';

export function BaselineOverlay({ visible }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!visible) {
      setShow(false);
      return;
    }
    const t = setTimeout(() => setShow(true), 3000);
    return () => clearTimeout(t);
  }, [visible]);

  return (
    <div className={`baseline-overlay ${show ? 'visible' : ''}`}>
      <div className="baseline-content">
        <div className="baseline-word baseline-word-1">KRONOTERA</div>
        <div className="baseline-divider" />
        <div className="baseline-sub">
          <span className="baseline-word baseline-word-2">Voyager</span>
          <span className="baseline-word baseline-word-3">à travers</span>
          <span className="baseline-word baseline-word-4">le temps</span>
        </div>
        <div className="baseline-hint">Cliquez sur un point du globe pour commencer</div>
      </div>
    </div>
  );
}
